import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';

import { TOTAL_STEPS } from '@components/tenantStatus/onboardingWizard/constants';
import type { WizardProgressProps } from '@components/tenantStatus/onboardingWizard/types';

const WizardProgress = ({ C, currentStep, testID }: WizardProgressProps) => {
  const filled = C('Other/Light/Logo/Smart');
  const empty = C('Hairline/Light/No trans [mobile]');

  return (
    <View testID={testID} style={{ width: '100%' }}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        {Array.from({ length: TOTAL_STEPS }).map((_, index) => {
          const isActive = index < currentStep;
          return (
            <View
              key={index}
              style={{
                flex: 1,
                height: scale(3),
                borderRadius: scale(2),
                backgroundColor: isActive ? filled : empty,
                marginRight: index === TOTAL_STEPS - 1 ? 0 : scale(8),
              }}
            />
          );
        })}
      </View>
      <Text
        style={[
          font['Footnote'],
          { color: C('Label/Light/Tertiary'), marginTop: scale(6), textAlign: 'right' },
        ]}
      >
        {i18n.t('Step {{current}} of {{total}}', { current: currentStep, total: TOTAL_STEPS })}
      </Text>
    </View>
  );
};

export default WizardProgress;
